/* ALTF4 "Search this collection" — 13 Sep 2026.
 *
 * April: "when you hit like steam launcher, if you want to search that collection for a game, i want
 * the box to be there." Wording approved by April: box "Search this collection", no results
 * "No matches in this collection".
 *
 * Shopify's search cannot be limited to one collection, so this searches the collection's OWN
 * product list: /collections/<handle>/products.json, 250 per request, fetched once per page view
 * (4 requests at a time) and kept in memory. Every word typed must appear in the product's title or
 * handle (matching only; nothing from the title is displayed). Matches are shown with the real card,
 * fetched 24 at a time from /products/<handle>?section_id=altf4-card-render; the next 24 load when
 * the end of the results comes into view.
 *
 * While a search is active the normal grid, its infinite-scroll marker and the pager are hidden and
 * the result count shows the number of matches; clearing the box (or fewer than 2 characters)
 * restores the page exactly. Products without a cover are skipped, same as the grid.
 * ⚠️ Active sidebar filters are NOT applied to these matches — products.json ignores them.
 * ⚠️ The Claude browser preview pane never fires IntersectionObserver, so only the first 24 matches
 *    show there; a real browser loads the rest on scroll.
 */
(function () {
  'use strict';
  if (window.__af4ColSearchBound) return;
  window.__af4ColSearchBound = true;

  var PAGE = 250, BATCH = 24, CONC_INDEX = 4, CONC_CARDS = 6, DEBOUNCE = 300, MIN_CHARS = 2;
  var indexes = {};
  var runId = 0, timer = null, observer = null, pending = [];

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function loadIndex(handle) {
    if (indexes[handle]) return indexes[handle];
    indexes[handle] = new Promise(function (resolve) {
      var out = [], seen = {}, page = 1;
      function batch() {
        var pages = [];
        for (var i = 0; i < CONC_INDEX; i++) pages.push(page + i);
        page += CONC_INDEX;
        Promise.all(pages.map(function (p) {
          return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + PAGE + '&page=' + p)
            .then(function (r) { return r.ok ? r.json() : { products: [] }; })
            .catch(function () { return { products: [] }; });
        })).then(function (results) {
          var finished = false;
          results.forEach(function (j) {
            var list = (j && j.products) || [];
            if (list.length < PAGE) finished = true;
            list.forEach(function (p) {
              if (seen[p.handle]) return;
              seen[p.handle] = true;
              out.push({
                handle: p.handle,
                text: norm(p.title + ' ' + String(p.handle).replace(/-/g, ' ')),
                hasImage: !!(p.images && p.images.length)
              });
            });
          });
          if (finished) resolve(out); else batch();
        });
      }
      batch();
    });
    return indexes[handle];
  }

  function parts(form) {
    var root = form.closest('[data-af4-results]') || document;
    return {
      root: root,
      grid: root.querySelector('[data-af4-grid]'),
      results: root.querySelector('[data-af4-colsearch-results]'),
      empty: root.querySelector('[data-af4-colsearch-empty]'),
      count: root.querySelector('[data-af4-count-n]'),
      marker: root.querySelector('[data-af4-loadmore]'),
      pager: root.querySelector('.af4-pager')
    };
  }

  function stopObserver() {
    if (observer) { observer.disconnect(); observer = null; }
  }

  function restore(e) {
    stopObserver();
    pending = [];
    e.root.removeAttribute('aria-busy');
    if (e.results) { e.results.innerHTML = ''; e.results.hidden = true; }
    if (e.empty) e.empty.hidden = true;
    if (e.grid) e.grid.hidden = false;
    if (e.marker) e.marker.hidden = false;
    if (e.pager) e.pager.hidden = false;
    if (e.count && e.count.hasAttribute('data-af4-orig')) e.count.textContent = e.count.getAttribute('data-af4-orig');
  }

  function renderNext(e, id) {
    stopObserver();
    var batch = pending.splice(0, BATCH);
    if (!batch.length) return;
    var htmls = new Array(batch.length), next = 0, running = 0;

    new Promise(function (resolve) {
      function pump() {
        if (id !== runId) { resolve(); return; }
        if (next >= batch.length && running === 0) { resolve(); return; }
        while (running < CONC_CARDS && next < batch.length) {
          (function (k) {
            running++;
            fetch('/products/' + encodeURIComponent(batch[k]) + '?section_id=altf4-card-render')
              .then(function (r) { return r.ok ? r.text() : ''; })
              .catch(function () { return ''; })
              .then(function (html) { htmls[k] = html; running--; pump(); });
          })(next++);
        }
      }
      pump();
    }).then(function () {
      if (id !== runId) return;
      htmls.forEach(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sec = doc.querySelector('.shopify-section') || doc.body;
        while (sec.firstElementChild) e.results.appendChild(sec.firstElementChild);
      });
      if (!pending.length) return;
      if (!('IntersectionObserver' in window)) { renderNext(e, id); return; }
      var marker = document.createElement('div');
      marker.className = 'af4-infscroll';
      marker.setAttribute('aria-hidden', 'true');
      e.results.appendChild(marker);
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting || !observer) return;
          stopObserver();
          if (marker.parentNode) marker.parentNode.removeChild(marker);
          renderNext(e, id);
        });
      }, { rootMargin: '300px' });
      observer.observe(marker);
    });
  }

  function search(form, q) {
    var id = ++runId;
    var e = parts(form);
    if (!e.grid || !e.results || !e.empty) return;
    if (e.count && !e.count.hasAttribute('data-af4-orig')) e.count.setAttribute('data-af4-orig', e.count.textContent);
    e.root.setAttribute('aria-busy', 'true');

    loadIndex(form.getAttribute('data-af4-handle')).then(function (items) {
      if (id !== runId) return;
      var tokens = norm(q).split(' ').filter(Boolean);
      var matches = items.filter(function (it) {
        if (!it.hasImage) return false;
        for (var i = 0; i < tokens.length; i++) if (it.text.indexOf(tokens[i]) === -1) return false;
        return true;
      });
      stopObserver();
      e.root.removeAttribute('aria-busy');
      e.grid.hidden = true;
      if (e.marker) e.marker.hidden = true;
      if (e.pager) e.pager.hidden = true;
      if (e.count) e.count.textContent = matches.length;
      e.results.innerHTML = '';
      e.results.hidden = matches.length === 0;
      e.empty.hidden = matches.length !== 0;
      pending = matches.map(function (m) { return m.handle; });
      renderNext(e, id);
    });
  }

  document.addEventListener('input', function (ev) {
    var input = ev.target && ev.target.closest && ev.target.closest('[data-af4-colsearch-input]');
    if (!input) return;
    var form = input.closest('[data-af4-colsearch]');
    if (!form) return;
    clearTimeout(timer);
    var q = input.value.trim();
    timer = setTimeout(function () {
      if (q.length < MIN_CHARS) { runId++; restore(parts(form)); }
      else search(form, q);
    }, DEBOUNCE);
  });

  document.addEventListener('submit', function (ev) {
    if (ev.target && ev.target.closest && ev.target.closest('[data-af4-colsearch]')) ev.preventDefault();
  });
})();
